import { getConfig } from '@monorepo/tools/src/lib/get-config';
import { getManagementApiBaseUrl } from '../../utils/management-api';

export class AdminxReporterEndpoint {
	report() {
		const { localReportApi } = getConfig().env;

		return localReportApi ? `${localReportApi}/report` : `${getManagementApiBaseUrl()}/reports/report`;
	}

	newReport() {
		return `${this.report()}/repr`;
	}
}
